import { MenuItem as MUIMenuItem } from "@mui/material";
import { styled } from "@mui/material/styles";

import { StyledMenu } from "../../../AnchorMenu";
import GenericModal from "../../../Modal";

export const Menu = styled(StyledMenu)(() => ({
  marginTop: "52px",
  "& .MuiListItem-button:hover": {
    backgroundColor: "#EDF5FB",
    color: "#308CDB",
    fontWeight: 600,
  },
}));

export const MenuItem = styled(MUIMenuItem)(() => ({
  color: "#667085",
  fontWeight: 500,
  fontSize: "14px",
  fontFamily: "Manrope",
  minWidth: "148px",
  height: "40px",
}));

export const Modal = styled(GenericModal)(() => ({
  maxWidth: "40vw",
  minWidth: "442px !important",
  "@media screen and (max-width: 1024px)": {
    minWidth: "60vw !important",
  },
}));
